import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

interface BaseProps {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
}

function classes({ variant = "secondary", size = "md", block, className }: BaseProps) {
  return [
    "btn",
    `btn--${variant}`,
    size !== "md" && `btn--${size}`,
    block && "btn--block",
    className,
  ]
    .filter(Boolean)
    .join(" ");
}

export function Button({
  variant,
  size,
  block,
  loading,
  icon,
  children,
  className,
  disabled,
  ...rest
}: BaseProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={classes({ variant, size, block, className })}
    >
      {loading ? <span className="btn__spinner" aria-hidden /> : icon}
      {children}
    </button>
  );
}

/** Same visual language, but renders a router link. */
export function ButtonLink({
  to,
  variant,
  size,
  block,
  icon,
  children,
  className,
}: BaseProps & { to: string }) {
  return (
    <Link to={to} className={classes({ variant, size, block, className })}>
      {icon}
      {children}
    </Link>
  );
}
